import api from './client'

/** GET /api/teachers/ — teacher directory with follow stats */
export const listTeachers = (search, config) =>
  api.get('/api/teachers/', { ...config, params: search ? { search } : {} })

/** POST /api/teachers/:id/follow/ */
export const followTeacher = (id) => api.post(`/api/teachers/${id}/follow/`)

/** POST /api/teachers/:id/unfollow/ */
export const unfollowTeacher = (id) => api.post(`/api/teachers/${id}/unfollow/`)

/** GET /api/teachers/following/ — teachers the student currently follows */
export const getFollowingTeachers = (config) => api.get('/api/teachers/following/', config)

/** GET /api/exams/upcoming/ — upcoming public exams from followed teachers */
export const getUpcomingExams = (config) => api.get('/api/exams/upcoming/', config)

/** GET /api/stats/me/ — student stats (Natijalarim) */
export const getMyStats = (config) => api.get('/api/stats/me/', config)

/** GET /api/leaderboard/ — global leaderboard (Reyting) */
export const getGlobalLeaderboard = (params = {}, config) =>
  api.get('/api/leaderboard/', { ...config, params })

/** GET /api/teachers/:id/ — teacher detail (subjects, follow stats, recent exams) */
export const getTeacher = (id, config) => api.get(`/api/teachers/${id}/`, config)

/** GET /api/homework/ — homework feed (follow-scoped for students) */
export const listHomework = (config) => api.get('/api/homework/', config)

/** POST /api/homework/:id/complete/ — mark homework done */
export const completeHomework = (id) => api.post(`/api/homework/${id}/complete/`)

/** DELETE /api/homework/:id/complete/ — mark homework undone */
export const uncompleteHomework = (id) => api.delete(`/api/homework/${id}/complete/`)

/** GET /api/exams/calendar/?year=&month= — exams starting in the given month (public) */
export const getCalendarExams = (year, month, config) =>
  api.get('/api/exams/calendar/', { ...config, params: { year, month } })
